var map = {
	"./Realtimeinventory.png": "./src/assets/images/kanban/Realtimeinventory.png",
	"./arriveNumber.png": "./src/assets/images/kanban/arriveNumber.png",
	"./customerOrderReduction.png": "./src/assets/images/kanban/customerOrderReduction.png",
	"./customerOrderReduction0.png": "./src/assets/images/kanban/customerOrderReduction0.png",
	"./equivalenceProblemPieces.png": "./src/assets/images/kanban/equivalenceProblemPieces.png",
	"./kanban01.png": "./src/assets/images/kanban/kanban01.png",
	"./kanban02.png": "./src/assets/images/kanban/kanban02.png",
	"./kanban03.png": "./src/assets/images/kanban/kanban03.png",
	"./kanban04.png": "./src/assets/images/kanban/kanban04.png",
	"./kanban05.png": "./src/assets/images/kanban/kanban05.png",
	"./kanban06.png": "./src/assets/images/kanban/kanban06.png",
	"./kanban07.png": "./src/assets/images/kanban/kanban07.png",
	"./kanban08.png": "./src/assets/images/kanban/kanban08.png",
	"./kanban09.png": "./src/assets/images/kanban/kanban09.png",
	"./onTouring.png": "./src/assets/images/kanban/onTouring.png",
	"./problemItemLessThan.png": "./src/assets/images/kanban/problemItemLessThan.png",
	"./questionItemGreaterThan.png": "./src/assets/images/kanban/questionItemGreaterThan.png",
	"./senderNumber.png": "./src/assets/images/kanban/senderNumber.png",
	"./todayEquals.png": "./src/assets/images/kanban/todayEquals.png",
	"./todayGreaterThan.png": "./src/assets/images/kanban/todayGreaterThan.png",
	"./todayLessThan.png": "./src/assets/images/kanban/todayLessThan.png",
	"./yuan.png": "./src/assets/images/kanban/yuan.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/kanban sync recursive ^\\.\\/.*\\.png$";